module.exports = __webpack_public_path__ + "img/cellular-automata.a20525a6.png";